import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, NgZone, OnDestroy, ɵConsole } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { auth } from 'firebase/app';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { retry, retryWhen, delay, tap,map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Roles } from '../interfaces/interfaces';
import { SessionService } from './session.service';
import { TablaIniciativasComponent } from 'src/app/components/administracion/tabla-iniciativas/tabla-iniciativas.component';
import { NavbarComponent } from 'src/app/components/shared/navbar/navbar.component';

@Injectable({
  providedIn: 'root'
})
export class AuthService{
  urlToken: string;
  urlAPI2:String;
  public isAdmin = new Subject<boolean>();
  public isVIP = new BehaviorSubject<boolean>(false);
  public rol = new BehaviorSubject<number>(0);
  public email = new BehaviorSubject<string>('');
  public userRoles: BehaviorSubject<any>;
  public correoUser: BehaviorSubject<any>;
  rolesUsuario: number[] = [0];
  roles: Roles[]=[];
  sandbox:boolean=false; //modo caja de arena solo para pruebas en local, evita que al recargar la pantalla tras un cambio loguearse nuevamente, 
  rolSanbox:number=2;
  public rolesNav = new BehaviorSubject<Roles[]>([]);
  //Objeto de la clase tabla iniiativas
  tablaIniciativas:TablaIniciativasComponent;
  
  
  user = this.fbAuth.authState.pipe(
    map(authState => {
      if (!authState) {
        if(this.sandbox){
          this.email.next("jfloresgon@guanajuato.gob.mx");
          return "jfloresgon@guanajuato.gob.mx";
        }else{
          return null
        }
      } else {
        this.email.next(authState.email);
        return authState.email;
      }
    })
  );
  userName = this.fbAuth.authState.pipe(
    map(authState => {
      if (!authState) {
        if(this.sandbox){
          return "Armando Flores";
        }else{
          return null;
        }
      } else {
        return authState.displayName;
      }
    })
  );

  obtenerRoles(): number[] {
    return this.rolesUsuario;
  }

  public obtenerEmailUser(): Observable<string> {
    return this.email.asObservable();
  }

  //Emitter para evento de seleccionar rol
  nombreRol$=new EventEmitter<number>();

  constructor(
    private fbAuth: AngularFireAuth,
    private router: Router,
    private http: HttpClient,
    private zone: NgZone,
    public _session: SessionService,
    //public navBar:NavbarComponent
  ) {
    // verificar si esta en modo productivo o calidad
    this.urlToken=environment.urlToken;
    this.urlAPI2=environment.UrlApiV2;
    this.isAdmin.next(false);
    this.isVIP.next(false);
    this.userRoles = new BehaviorSubject<any>(localStorage.getItem ("rolesUsuario"));
    this.correoUser = new BehaviorSubject<any>(null);
  }

  //Mètodo para escuchar/subscribirse el rol seleccionado
  public escuchaRolSeleccionado(): Observable<number> {
    if(this.sandbox){
    this.rol.next(this.rolSanbox);
    }
    return this.rol.asObservable();
  }


  public escuchaRolesUser(): Observable<Roles[]> {
    return this.rolesNav.asObservable();
  }

  public onGetAllRolesUsuario(): Observable<any> {
    return this.userRoles.asObservable();
  }

  public onGetCorreo(): Observable<any> {
    return this.correoUser.asObservable();
  }
  
  
  //Mètodo para emitir el rol seleccionado
  public emiteRolSeleccionado(id:number): void {
    this.rol.next(id);
    if(id==9 || id==10 || id==11 || id==3 || id==4 || id==5 || id==12 || id==6 || id==7 || id==8)
    {
      
      this.zone.run(() => this.router.navigate(['/iniciativas']));
    }
    else{
      if(id==13)
      {
        this.zone.run(() => this.router.navigate(['/administracion']));
      }else
      {
        this.zone.run(() => this.router.navigate(['/mis-iniciativas']));

      }
    }
	}

   signInWithProvider(): Observable<string> {
    return new Observable(observer => {
      this.fbAuth.auth
        .signInWithPopup(new auth.GoogleAuthProvider())
        .then(async result => {
          const user = {
            opcion: 0,
            email_usuario: result.user.email
          };
          //Credential firebase
          const credential= 
          {
            opcion: environment.GOOGLE_LOGIN,
            username: result.user.email,
            password: result.credential['accessToken'],
            grant_type: environment.GRANT_TYPE,
            client_Id: environment.CLIENT_ID
          }
         //Generamos el token
          let promiseB = await this.generateToken(credential).then(function(result) {
            return result;
          });
          this.isAutorized(user).subscribe(
            res => {
              if (res['errorMessage']) {
                console.error('Error al intentar autenticar usuario: ', res['errorMessage']);
                this.logOut();
                observer.next('Error al comunicarse con el servidor de aplicaciones. ' +
                'Póngase en contacto con el área soporte técnico para solucionar el problema.');
                observer.complete();
              } else {
                if (res['alert'].toString() === '0' && res['objData']['response']=== '1') 
                {
                  if (res['status'] === 'OK') 
                  {
                    if (res['objData'].roles.split(',').find((x: string) => x === '3' || x === '4' || x === '5' || x === '1' || x === '2')) {
                      this.isAdmin.next(true);
                    }
                    this.rolesUsuario = res['objData'].roles.split(',').map(Number);
                    localStorage.setItem ("rolesUsuario", JSON.stringify(this.rolesUsuario));
                    if(this.sandbox){
                      this.correoUser.next("jfloresgon@guanajuato.gob.mx");
                    }else{
                      this.correoUser.next(result.user.email);
                    }
                    this.userRoles.next(JSON.stringify(this.rolesUsuario));
                    //------------------------------------
                    let r=res['objData'].json_roles;
                    let rolesC=JSON.parse(r);
                   //Mapeamos los roles del usuario logueado
                    this.roles=rolesC;
                    this.rolesNav.next(rolesC);
                  
                    // Verificar si el usuario es VIP
                    if (res['objData'].vip_usuario === true) {
                      this.isVIP.next(true);
                    } else {
                      this.isVIP.next(false);
                    }
                    // Redireccionar a selecionar un rol
                    this.zone.run(() => this.router.navigate(['/seleccion-rol']));

                  } else {
                    this.logOut();
                    observer.next('La cuenta de usuario se encuentra bloqueada.');
                    observer.complete();
                  }
                } else if (res['objData']['response'] === '0') {
                  this.logOut();
                  observer.next('La cuenta de usuario no tiene autorización para entrar al portal.');
                  observer.complete();
                }
              }
            }
          );
        })
        .catch((reason: any) => {
          observer.next('Ha ocurrido un problema al conectarse con Google. Intenta de nuevo más tarde.');
          console.log(reason);
          observer.complete();
        });
    });
  }

  
  
  logOut() {
    if(this.rol.value!=0){
      this.nombreRol$.unsubscribe();
      window.location.reload();
    }
   this.fbAuth.auth
      .signOut()
      .then(() => {
        if(!this.sandbox){
          localStorage.clear();
          this.zone.run(() => this.router.navigate(['/login']));
        }
      })
      .catch((err: any) => {
        console.log('err');
      });
      this._session.removeSessionOnStorage();
      
  }

  /*Método para verificar si el usuario esta autorizado*/
  isAutorized=(usuario: any)=> {
    return this.http.post(`${this.urlAPI2}users/getUserByEmail`,usuario);
  }

 
  isAuthenticated(): Observable<boolean> {
    return this.fbAuth.authState.pipe(
      map(authState => {
        if (!authState) {
          if(this.sandbox){
            return true;
          }else{
            return false;
          }
        } else {
          return true;
        }
      })
    );
  }

  isInRole(rol: number): boolean {
    if (this.rolesUsuario.find((x: number) => x === rol) !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  // Metodo para poder navegar en el sitio sin login, solo en modo de pruebas
  noSignIn() {
    this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
  }

  
  ngOnDestroy () { 
    this._session.removeSessionOnStorage();
    this.nombreRol$.unsubscribe();
  } 


   generateToken(credential: any) {
    const body = new URLSearchParams();
    body.set('username',credential.username);
    body.set('password', credential.password);
    body.set('opcion',credential.opcion),
    body.set('grant_type',credential.grant_type);
    body.set('client_id', credential.client_Id);

    return this.http
      .post(
        `${this.urlToken}token`,
        body.toString(),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      )
      .toPromise()
      .then(token => {
        this._session.token = token['access_token']
        this._session.refreshToken = token['refresh_token']
        this._session.setItem('authorization', token)
      })
  }

  
  
  refreshToken() {
    const body = new URLSearchParams();
    body.set('refresh_token', this._session.refreshToken);
    body.set('grant_type', 'refresh_token');
    body.set('client_id', environment.CLIENT_ID);

    return this.http.post(
      `${this.urlToken}token`,
      body.toString(),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    ).pipe(
      tap(token => {
        this._session.token = token['access_token']
        this._session.refreshToken = token['refresh_token']
        this._session.setItem('authorization', token)
      }),
      retry(1),
      catchError((e: any) => {
        this._session.isRefreshing = false;
        this.logOut()
        return e
      })
    )
  }

 
}
